"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOriginalLine = getOriginalLine;
exports.compilerWarnings = compilerWarnings;
exports.terminalOutput = terminalOutput;
const jeed_types_1 = require("@cs124/jeed-types");
function getOriginalLine(request, line, source) {
    if (request.snippet) {
        return request.snippet.split("\n")[line - 1];
    }
    for (const { path, contents } of request.sources || []) {
        if (source === path || source === `/${path}`) {
            return contents.split("\n")[line - 1];
        }
    }
    throw new Error(`Couldn't find line ${line} in source ${source}`);
}
function compilerWarnings(response) {
    var _a;
    if (!(response.completed.compilation || response.completed.kompilation)) {
        return;
    }
    return (((_a = (response.completed.compilation || response.completed.kompilation)) === null || _a === void 0 ? void 0 : _a.messages.filter(({ kind }) => kind === "WARNING").map((error) => {
        const { location, message } = error;
        if (location) {
            const { source, line, column } = location;
            const originalLine = getOriginalLine(response.request, line, source);
            const firstErrorLine = message.split("\n").slice(0, 1).join();
            const restOfError = message
                .split("\n")
                .slice(1)
                .filter((line) => {
                return !(source === "" && line.trim().startsWith("location: class"));
            })
                .join("\n");
            return `${source === "" ? "Line " : `${source}:`}${line}: error: ${firstErrorLine}
${originalLine ? originalLine + "\n" + new Array(column).join(" ") + "^" : ""}${restOfError ? "\n" + restOfError : ""}`;
        }
        else {
            return message;
        }
    }).join("\n")) || "");
}
function terminalOutput(response) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { request } = response;
    if (response.failed.snippet) {
        const output = response.failed.snippet.errors
            .map(({ line, column, message }) => {
            const originalLine = getOriginalLine(request, line);
            return `Line ${line}: error: ${message}
  ${originalLine ? originalLine + "\n" + new Array(column).join(" ") + "^" : ""}`;
        })
            .join("\n");
        const errorCount = Object.keys(response.failed.snippet.errors).length;
        return {
            output: `${output}
  ${errorCount} error${errorCount > 1 ? "s" : ""}`,
            level: "error",
        };
    }
    else if (response.failed.compilation || response.failed.kompilation) {
        const output = ((_a = (response.failed.compilation || response.failed.kompilation)) === null || _a === void 0 ? void 0 : _a.errors.map((error) => {
            const { location, message } = error;
            if (location) {
                const { source, line, column } = location;
                const originalLine = getOriginalLine(request, line, source);
                const firstErrorLine = message.split("\n").slice(0, 1).join();
                const restOfError = message
                    .split("\n")
                    .slice(1)
                    .filter((line) => {
                    return !(source === "" && line.trim().startsWith("location: class"));
                })
                    .join("\n");
                return `${source === "" ? "Line " : `${source}:`}${line}: error: ${firstErrorLine}
${originalLine ? originalLine + "\n" + new Array(column).join(" ") + "^" : ""}${restOfError ? "\n" + restOfError : ""}`;
            }
            else {
                return message;
            }
        }).join("\n")) || "";
        const errorCount = Object.keys(((_b = (response.failed.compilation || response.failed.kompilation)) === null || _b === void 0 ? void 0 : _b.errors) || {}).length;
        return {
            output: `${output}
  ${errorCount} error${errorCount > 1 ? "s" : ""}`,
            level: "error",
        };
    }
    else if (response.failed.checkstyle) {
        const output = ((_c = response.failed.checkstyle) === null || _c === void 0 ? void 0 : _c.errors.map(({ location: { source, line }, message }) => {
            return `${source === "" ? "Line " : `${source}:`}${line}: checkstyle error: ${message}`;
        }).join("\n")) || "";
        const errorCount = Object.keys(((_d = response.failed.checkstyle) === null || _d === void 0 ? void 0 : _d.errors) || {}).length;
        return {
            output: `${output}
  ${errorCount} error${errorCount > 1 ? "s" : ""}`,
            level: "error",
        };
    }
    else if (response.failed.ktlint) {
        const output = ((_e = response.failed.ktlint) === null || _e === void 0 ? void 0 : _e.errors.map(({ location: { source, line }, detail }) => {
            return `${source === "" ? "Line " : `${source}:`}${line}: ktlint error: ${detail}`;
        }).join("\n")) || "";
        const errorCount = Object.keys(((_f = response.failed.ktlint) === null || _f === void 0 ? void 0 : _f.errors) || {}).length;
        return {
            output: `${output}
  ${errorCount} error${errorCount > 1 ? "s" : ""}`,
            level: "error",
        };
    }
    else if (response.failed.disassemble) {
        return { output: response.failed.disassemble.message, level: "error" };
    }
    else if (response.failed.execution || response.failed.cexecution) {
        const failed = response.failed.execution || response.failed.cexecution;
        if (failed === null || failed === void 0 ? void 0 : failed.classNotFound) {
            return { output: `Error: could not find class ${failed === null || failed === void 0 ? void 0 : failed.classNotFound}`, level: "error" };
        }
        else if (failed === null || failed === void 0 ? void 0 : failed.methodNotFound) {
            return { output: `Error: could not find method ${failed === null || failed === void 0 ? void 0 : failed.methodNotFound}`, level: "error" };
        }
        else {
            return { output: `Something unexpected went wrong. Please report a bug.`, level: "error" };
        }
    }
    if (Object.keys(response.failed).length === 0) {
        if (response.completed.execution || response.completed.cexecution) {
            let level = "success";
            const completed = response.completed.execution || response.completed.cexecution;
            const output = (completed === null || completed === void 0 ? void 0 : completed.outputLines)
                ? completed.outputLines.length > 0
                    ? completed.outputLines.map(({ line }) => line)
                    : ((_g = response.completed.execution) === null || _g === void 0 ? void 0 : _g.threw)
                        ? []
                        : [`(Completed without output)`]
                : [];
            if ((_h = response.completed.execution) === null || _h === void 0 ? void 0 : _h.killReason) {
                level = "error";
                output.push(`Execution did not complete: ${(_j = jeed_types_1.KILL_REASONS[response.completed.execution.killReason]) !== null && _j !== void 0 ? _j : response.completed.execution.killReason}.`);
            }
            else if ((_k = response.completed.execution) === null || _k === void 0 ? void 0 : _k.threw) {
                level = "error";
                output.push(`Threw an exception: ${(_l = response.completed.execution) === null || _l === void 0 ? void 0 : _l.threw.stacktrace}`);
            }
            else if (completed === null || completed === void 0 ? void 0 : completed.timeout) {
                level = "error";
                output.push("(Program timed out)");
            }
            if ((completed === null || completed === void 0 ? void 0 : completed.truncatedLines) || 0 > 0) {
                level = "warning";
                output.push(`(${completed === null || completed === void 0 ? void 0 : completed.truncatedLines} lines were truncated)`);
            }
            return { output: output.join("\n"), level };
        }
        else if (response.completed.checkstyle) {
            return { output: `No checkstyle errors found`, level: "success" };
        }
        else if (response.completed.ktlint) {
            return { output: `No ktlint errors found`, level: "success" };
        }
        else if (response.completed.complexity) {
            const results = response.completed.complexity.results;
            const output = [];
            for (const result of results) {
                const totalComplexity = result.classes.map(({ complexity }) => complexity).reduce((c, n) => n + c, 0);
                const name = result.source === "" ? "Entire snippet" : result.source;
                output.push(`${name} has complexity ${totalComplexity}`);
                for (const klass of result.classes) {
                    if (klass.name === "") {
                        continue;
                    }
                    output.push(`  Class ${klass.name} has complexity ${klass.complexity}`);
                }
                for (const method of result.methods) {
                    const methodName = method.name === "" ? "Loose code" : `Method ${method.name}`;
                    output.push(`  ${methodName} has complexity ${method.complexity}`);
                }
            }
            return { output: output.join("\n"), level: "success" };
        }
        else if (response.completed.disassemble) {
            const results = response.completed.disassemble.disassemblies;
            const classListings = [];
            for (const klass of Object.keys(results).sort()) {
                classListings.push(results[klass]);
            }
            return { output: classListings.join("\n\n\n"), level: "success" };
        }
        if (response.completed.features) {
            const { results, allFeatures } = response.completed.features;
            const output = [];
            for (const result of results) {
                const fileFeatures = {};
                for (const klass of result.classes) {
                    for (const feature of Object.keys(klass.features.featureMap)) {
                        fileFeatures[feature] = true;
                    }
                }
                const name = result.source === "" ? "Entire snippet" : result.source;
                output.push(`${name} uses features ${Object.keys(fileFeatures)
                    .map((feature) => allFeatures[feature])
                    .sort()}`);
            }
            return { output: output.join("\n"), level: "success" };
        }
    }
    throw Error("Can't generate output for this result");
}
//# sourceMappingURL=index.js.map